import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80",
        outline: "text-foreground",
        green: "border-transparent bg-[#C6F6D5] text-[#38A169] shadow hover:bg-[#9AE6B4]", // Green
        yellow: "border-transparent bg-[#FEF3C7] text-[#D97706] shadow hover:bg-[#FDE68A]", // Yellow
        orange: "border-transparent bg-[#FDE8D6] text-[#F97316] shadow hover:bg-[#FBC77C]", // Orange
        red: "border-transparent bg-[#FEE2E2] text-[#EF4444] shadow hover:bg-[#FCA5A5]", // Red
        blue: "border-transparent bg-[#E2E8F0] text-[#334155] shadow hover:bg-[#CBD5E1]", // Slate
        gray: "border-transparent bg-[#F3F4F6] text-[#6B7280] shadow hover:bg-[#E5E7EB]", // Gray
        purple: "border-transparent bg-[#F3E8FF] text-[#7C3AED] shadow hover:bg-[#D8B4FE]", // Purple
        lightgray: "border-transparent bg-[#F9FAFB] text-[#9CA3AF] shadow hover:bg-[#E5E7EB]", // Light Gray
        cyan: "border-transparent bg-[#E0F7FA] text-[#00B8D4] shadow hover:bg-[#80DEEA]", // Cyan
        indigo: "border-transparent bg-[#E0E7FF] text-[#4F46E5] shadow hover:bg-[#C7D2FE]", // Indigo
        teal: "border-transparent bg-[#A7F3D0] text-[#14B8A6] shadow hover:bg-[#6EE7B7]", // Teal

      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
